import { __assign } from "tslib";
// DS: i10.14
import React from 'react';
import IconWrap from '../IconWrap';
var Flickr = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("g", null,
            React.createElement("path", { d: "M16.762 15.571a3.337 3.337 0 0 1-3.333-3.333 3.337 3.337 0 0 1 3.333-3.333 3.337 3.337 0 0 1 3.333 3.333 3.337 3.337 0 0 1-3.333 3.333M16.716 7A5.29 5.29 0 0 0 12 9.873 5.287 5.287 0 0 0 7.285 7C4.365 7 2 9.346 2 12.238c0 2.893 2.366 5.238 5.285 5.238A5.287 5.287 0 0 0 12 14.603a5.29 5.29 0 0 0 4.716 2.873c2.92 0 5.284-2.345 5.284-5.238C22 9.346 19.635 7 16.716 7" }))))); };
Flickr.displayName = 'Flickr';
export default Flickr;
//# sourceMappingURL=Flickr.js.map